module.exports = __webpack_public_path__ + "img/chipping2.4b0afe24.png";